import hotToast from 'react-hot-toast';

const COMMON_OPTS = {
  duration: 4000,
  style: {
    borderRadius: '8px',
    fontSize: '14px',
    padding: '12px 16px',
  },
};

export const toast = {
  success: (message, opts = {}) => hotToast.success(message, { ...COMMON_OPTS, ...opts }),
  error: (message, opts = {}) => hotToast.error(message, { ...COMMON_OPTS, ...opts }),
  info: (message, opts = {}) => hotToast(message, { ...COMMON_OPTS, ...opts }),
  loading: (message, opts = {}) => hotToast.loading(message, { ...COMMON_OPTS, ...opts }),
  dismiss: (id) => hotToast.dismiss(id),
  promise: (promise, messages, opts = {}) => hotToast.promise(promise, messages, { ...COMMON_OPTS, ...opts }),
};

export default toast;
